import { createAsyncThunk } from '@reduxjs/toolkit';
import { securedAxiosInstance } from '../../../api/axios';

export const getJournals = createAsyncThunk(
  'journals/getJournals',
  async (arg, { rejectWithValue }) => {
    try {
      const response = await securedAxiosInstance.get(`/journals`);
      return response;
    } catch (error) {
      if (error.response && error.response.data.error) {
        return rejectWithValue(error.response);
      } else {
        return rejectWithValue(error.message);
      }
    }
  }
);

export const getJournalByDate = createAsyncThunk(
  'journals/getJournalByDate',
  async ({ date }, { rejectWithValue }) => {
    try {
      const response = await securedAxiosInstance.get(`/journals/date/${date}`);
      return response;
    } catch (error) {
      if (error.response && error.response.data.error) {
        return rejectWithValue(error.response);
      } else {
        return rejectWithValue(error.message);
      }
    }
  }
);

export const saveJournal = createAsyncThunk(
  'journals/saveJournal',
  async ({ entry, dateOfEntry, isUpdate }, { getState, rejectWithValue }) => {
    try {
      let response;
      const data = {
        entry,
        date_of_entry: dateOfEntry,
      };
      if (isUpdate.state) {
        response = await securedAxiosInstance.put(
          `/journals/${isUpdate.journal.id}`,
          data
        );
      } else {
        response = await securedAxiosInstance.post(`/journals`, data);
      }

      return response;
    } catch (error) {
      if (error.response && error.response.data.error) {
        return rejectWithValue(error.response);
      } else {
        return rejectWithValue(error.message);
      }
    }
  }
);

export const deleteJournal = createAsyncThunk(
  'journals/deleteJournal',
  async ({ id }, { getState, rejectWithValue }) => {
    try {
      const response = await securedAxiosInstance.delete(`/journals/${id}`);
      return response;
    } catch (error) {
      if (error.response && error.response.data.error) {
        return rejectWithValue(error.response);
      } else {
        return rejectWithValue(error.message);
      }
    }
  }
);
